import { configureStore } from "@reduxjs/toolkit";
import { cmaBackendApi } from "@realtorSitesClient/clients/vowApi/api";
import authReducer from "./authSlice";
import propertySearchReducer from "./propertySearchSlice";
import modalReducer from "./modalSlice";
import appConfigReducer from "./appConfigSlice";
import headerReducer from "./headerSlice";
import { useDispatch } from "react-redux";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  PersistConfig,
  REGISTER,
  REHYDRATE,
  persistCombineReducers,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig: PersistConfig<any> = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth", "appConfig"],
};

const persistedReducer = persistCombineReducers(persistConfig, {
  [cmaBackendApi.reducerPath]: cmaBackendApi.reducer,
  appConfig: appConfigReducer,
  auth: authReducer,
  header: headerReducer,
  modal: modalReducer,
  propertySearch: propertySearchReducer,
});

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(cmaBackendApi.middleware),
});
export const persistor = persistStore(store);

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
